import { bartender } from './bartender';
import { listener } from './listener';
import { friend } from './friend';
import { tarotReader } from './tarotReader';

// 匯出所有的座位/角色設定，供 Bar.jsx 與 Chat.jsx 使用
// 新增了第四個角色：占卜師 (tarotReader)
export const seats = [
  bartender,
  listener,
  friend,
  tarotReader
];